import { useMedia } from 'react-use';
import { Global } from '../shared/constants';

export default function useResponsive(mediaWidth) {
  const isWide = useMedia(`(max-width: ${Global.mobMaxWidth}px)`);
  return { minWidth: 767, isMobile: isWide, screenWidth: window.innerWidth };
}
